const appHeight = () => {
	const doc = document.documentElement;
	doc.style.setProperty('--root-height', `${window.innerHeight}px`);
};
window.addEventListener('resize', appHeight);
appHeight();
